const TYPE = {
  TALENT: { value: 'TALENT', label: 'Talent' },
  STAKEHOLDER: { value: 'STAKEHOLDER', label: 'Customer / Stakeholder' }
};

const TYPES = Object.values(TYPE);

const getAllowedTaskTypesForRole = () => TYPES.map(item => item.value);

const getCreatableTaskTypesForRole = role => {
  if (role === 'HR') return [TYPE.TALENT.value];
  if (role === 'Account Executive') return [TYPE.STAKEHOLDER.value];
  return TYPES.map(item => item.value);
};

const canEditTaskTypeForRole = (role, taskType) => {
  if (role === 'HR') return taskType === 'employee' || taskType === TYPE.TALENT.value;
  if (role === 'Account Executive') return taskType === 'customer' || taskType === TYPE.STAKEHOLDER.value;
  return true;
};

const getTaskTitle = task => {
  const title = typeof task?.name === 'string' ? task.name.trim() : '';
  if (title) return title;
  const comment = typeof task?.comment === 'string' ? task.comment.trim() : '';
  if (comment) return comment.split('\n')[0].slice(0, 80);
  return task?.id ? `Task #${task.id}` : 'Task';
};

export { TYPES, TYPE, getAllowedTaskTypesForRole, getCreatableTaskTypesForRole, canEditTaskTypeForRole, getTaskTitle };
